import React from 'react';

import {
  Grid,
} from '@mui/material';

import { Student } from '../../../../services/students/types';
import { Metadata } from '../../../../services/types';
import AccountAccessCard from '../../SettingsTab/AccountAccessCard';
import GroupsCard from '../../SettingsTab/GroupsCard';
import PermissionsCard from '../../SettingsTab/PermissionsCard';

import AttendanceTypeCard from './AttendanceTypeCard';
import OtherDetailsCard from './OtherDetailsCard';
import StudentStateCard from './StudentStateCard';

interface SettingsTabProps {
  student?: Student,
  studentMetadata?: Metadata,
}

const SettingsTab = ({ student, studentMetadata }: SettingsTabProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <StudentStateCard student={student} metadata={studentMetadata} />
    </Grid>
    <Grid item xs={12}>
      <GroupsCard groups={student?.permissionGroups || []} />
    </Grid>
    <Grid item xs={12}>
      <PermissionsCard user={student} />
    </Grid>
    <Grid item xs={12}>
      <AttendanceTypeCard student={student} metadata={studentMetadata} />
    </Grid>
    <Grid item xs={12}>
      <OtherDetailsCard student={student} metadata={studentMetadata} />
    </Grid>
    <Grid item xs={12}>
      <AccountAccessCard user={student} />
    </Grid>
  </Grid>
);

export default SettingsTab;
